import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { getFormattedDate } from 'utils';

export const getDefaultDaysOptions = numDays => {
  return Array.from({ length: numDays }, (_, index) => {
    const date = moment().add(index + 1, 'days');
    return {
      id: uuidv4(),
      dayOfWeek: getFormattedDate(date, 'ddd'),
      formattedDate: getFormattedDate(date, 'DD MMM'),
      date: getFormattedDate(date),
    };
  });
};

export const getTableHeaderDateOptions = availability => {
  return availability?.map(({ date }) => ({
    id: uuidv4(),
    dayOfWeek: getFormattedDate(date, 'ddd'),
    formattedDate: getFormattedDate(date, 'DD MMM'),
    date: getFormattedDate(date),
  }));
};

export const acLedMappingSearchResultImportMapper = (data = {}) => {
  const { time_windows: timeWindows } = data ?? {};
  const mappedTimeWindows = Object.keys(timeWindows ?? {})?.reduce((res, key) => {
    const mappedTimeSlots = timeWindows?.[key]?.map(timeSlot => {
      const {
        time_slot: slotEndTime,
        time_slot: slotStartTime,
        is_highlighted: isHighlighted,
        teachers,
      } = timeSlot ?? {};
      const mappedTeachers = teachers?.map(
        ({
          teacher_id: id,
          teacher_name: name,
          score,
          is_recommended: isRecommended,
          end_time: endTime,
          start_time: startTime,
        }) => ({
          id,
          name,
          score,
          isRecommended,
          endTime,
          startTime,
        }),
      );

      return {
        slotStartTime,
        slotEndTime,
        isHighlighted,
        teachers: mappedTeachers,
      };
    });

    return {
      ...res,
      [key]: mappedTimeSlots,
    };
  }, {});

  return {
    timeWindows: mappedTimeWindows,
  };
};

export const studentDetailsImportMapper = data => {
  const {
    prospect_id: prospectID,
    student_name: name,
    student_id: id,
    parent_name: parentName,
    country_code: countryCode,
    phone,
    grade,
    school_board: schoolBoard,
    country,
    timezone,
    language,
  } = data || {};

  return {
    id,
    prospectID,
    name,
    parentName,
    phone: `+${countryCode}${phone}`,
    grade,
    schoolBoard,
    country,
    timezone,
    language,
  };
};

export const searchTeachersImportMapper = (data = {}) => {
  const {
    success,
    teachers,
    modal,
    is_referral_teacher_matched: isReferralTeacherMatched,
    referral_banner_message: referralBannerMessage,
    zone,
  } = data || {};
  const teachersMapped = teachers?.map(
    ({
      teacher_id: id,
      name,
      time_in_cuemath: timeInCuemath,
      students_taught: studentsTaught,
      students_in_selected_grade_cohort: studentsInSelectedGradeCohort,
      students_in_selected_country: studentsInSelectedCountry,
      availability,
      is_da_enabled_teacher: isDAenabledTeacher,
    }) => ({
      id,
      name,
      timeInCuemath,
      studentsTaught,
      studentsInSelectedGradeCohort,
      studentsInSelectedCountry,
      isDAenabledTeacher,
      availability: availability?.map(({ date, slots }) => ({
        id: uuidv4(),
        date,
        slots: slots?.map(({ start_time: slotStartTime, end_time: slotEndTime }) => ({
          id: uuidv4(),
          slotStartTime,
          slotEndTime,
        })),
      })),
    }),
  );
  return {
    zone,
    success,
    teachers: teachersMapped,
    modal,
    referralBannerMessage: isReferralTeacherMatched ? referralBannerMessage : null,
  };
};

export const teacherDetailsImportMapper = (teacherDetails = {}) => {
  const { teacher_id: id, name: name, score: score, score_details: scoreDetails } =
    teacherDetails ?? {};
  const {
    enrollments,
    sop_score: sopScore,
    student_density: studentDensity,
    plus_pac2paid: plusPacToPaid,
    base_pac2paid: basePacToPaid,
  } = scoreDetails ?? {};

  return {
    id,
    name,
    score,
    enrollments: enrollments ?? '--',
    sopScore: sopScore ?? '--',
    studentDensity: studentDensity ?? '--',
    plusPacToPaid: plusPacToPaid ?? '--',
    basePacToPaid: basePacToPaid ?? '--',
  };
};

export const mappingResultImportMapper = (result = {}) => {
  const {
    mapper_id: mapperId,
    prospect_id: prospectId,
    teachers,
    mapper_type: mapperType,
    student_id: studentId,
    student_name: studentName,
  } = result ?? {};

  return {
    mapperId,
    prospectId,
    teachers,
    studentId,
    studentName,
    mapperType,
  };
};
